
<script>
    import { selectedItem } from '../../../store/store.js';
</script>

<div class="key-value-table box">
    <h5>Upplåtelse och övergång</h5>

    <h6 style="font-weight: 500;">Krav på överlåtelseavtal</h6>
    <h6>{$selectedItem?.ownership_transfer?.transfer_agreement_requirements ?? "Uppgifter saknas"}</h6>

    <h6 style="font-weight: 500;">Medlemsrätt efter överlåtelse</h6>
    <h6>{$selectedItem?.ownership_transfer?.membership_rights_after_transfer ?? "Uppgifter saknas"}</h6>
</div>